    /*************************************************************
 * ModelPerformanceChart.js - Model performance radar chart
 *************************************************************/

import { useRef, useEffect } from 'react';

export const ModelPerformanceChart = ({ data, height = 300 }) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (!data || !chartRef.current) return;
        if (!window.Chart) return;

        if (chartInstance.current) {
            chartInstance.current.destroy();
        }

        const ctx = chartRef.current.getContext('2d');

        chartInstance.current = new Chart(ctx, {
            type: 'radar',
            data: {
                labels: ['Accuracy', 'Precision', 'Recall', 'F1 Score', 'Agreement Rate'],
                datasets: [{
                    label: 'Model Performance',
                    data: [
                        (data.accuracy_metrics?.overall_accuracy || 0) * 100,
                        (data.accuracy_metrics?.precision || 0) * 100,
                        (data.accuracy_metrics?.recall || 0) * 100,
                        (data.accuracy_metrics?.f1_score || 0) * 100,
                        data.overall_score || 0
                    ],
                    borderColor: '#007bff',
                    backgroundColor: 'rgba(0, 123, 255, 0.2)',
                    pointBackgroundColor: '#007bff',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: '#007bff'
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    r: {
                        beginAtZero: true,
                        max: 100,
                        ticks: {
                            stepSize: 20
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    }
                }
            }
        });

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, [data]);

    return (
        <canvas 
            ref={chartRef} 
            style={{ height: `${height}px` }}
        />
    );
};